import {
  CalculateSmsAmountPayload,
  CalculateSmsGroupAmountPayload,
  CalculateSmsRequestSpecialGroupPayload,
  MessageProps,
  SendSmsRequestGroupPayload,
  SendSmsRequestPayload,
  SendSmsRequestSpecialGroupPayload,
} from "@/models/payload/messages";
import clubRequest from "../axios";

const getAllMessagesRequest = async (params: MessageProps) =>
  (await clubRequest.smsSendRequestList(params)).data;

const getAllMessagesTemplates = async () =>
  (await clubRequest.smsTemplateList({ templateType: undefined })).data;

const calculateSmsTemplate = async (command: CalculateSmsAmountPayload) =>
  (await clubRequest.smsCalculateSmsAmountCreate(command)).data;

const calculateSmsTemplateByGroupId = async (
  command: CalculateSmsGroupAmountPayload
) => (await clubRequest.smsCalculateSmsGroupAmountCreate(command)).data;

const createSmsRequest = async (command: SendSmsRequestPayload) =>
  (await clubRequest.smsSendRequestCreate(command)).data;

const createSmsRequestByGroupId = async (command: SendSmsRequestGroupPayload) =>
  (await clubRequest.smsSendRequestGroupCreate(command)).data;

const calculateSmsRequestBySpecialGroupId = async (
  command: CalculateSmsRequestSpecialGroupPayload
) =>
  (await clubRequest.smsCalculateSmsSpecialGroupAmountCreate(command)).data;

const createSmsRequestBySpecialGroupId = async (
  command: SendSmsRequestSpecialGroupPayload
) => (await clubRequest.smsSendRequestSpecialGroupCreate(command)).data;

const messageService = {
  getAllMessagesRequest,
  getAllMessagesTemplates,
  calculateSmsTemplate,
  createSmsRequest,
  calculateSmsTemplateByGroupId,
  createSmsRequestByGroupId,
  createSmsRequestBySpecialGroupId,
  calculateSmsRequestBySpecialGroupId,
};

export default messageService;
